import {gql} from '@apollo/client'

export const CREATE_AGENT_REFERRAL_INVITATION = gql`
  mutation createAgentReferralInvitation($email: String!) {
    createAgentReferralInvitation(email: $email) {
      invitationToken
      inviteUrl
      emailSent
      success
      errors {
        field
        message
      }
    }
  }
`

/** Contracting-side review workflow. Independent of the applicant's own submission. */
export const UPDATE_AGENT_ONBOARDING_REVIEW_STATUS = gql`
  mutation updateAgentOnboardingReviewStatus($applicationId: ID!, $reviewStatus: String!) {
    updateAgentOnboardingReviewStatus(
      applicationId: $applicationId
      reviewStatus: $reviewStatus
    ) {
      success
      errors {
        field
        message
      }
      application {
        id
        reviewStatus
      }
    }
  }
`

/** "NOT_STARTED" borra la fila: ese estado es la ausencia de registro, no un valor guardado. */
export const SET_AGENT_ONBOARDING_CARRIER_APPOINTMENT = gql`
  mutation setAgentOnboardingCarrierAppointment(
    $applicationId: ID!
    $carrierId: ID!
    $status: String!
  ) {
    setAgentOnboardingCarrierAppointment(
      applicationId: $applicationId
      carrierId: $carrierId
      status: $status
    ) {
      success
      errors {
        field
        message
      }
      application {
        id
        carrierAppointments {
          carrierId
          carrierName
          status
        }
      }
    }
  }
`

export const UPDATE_AGENT_ONBOARDING_INTERNAL_NOTES = gql`
  mutation updateAgentOnboardingInternalNotes($applicationId: ID!, $internalNotes: String!) {
    updateAgentOnboardingInternalNotes(
      applicationId: $applicationId
      internalNotes: $internalNotes
    ) {
      success
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_AGENT_ONBOARDING_COMMISSION_LEVEL = gql`
  mutation updateAgentOnboardingCommissionLevel($applicationId: ID!, $commissionLevel: Int!) {
    updateAgentOnboardingCommissionLevel(
      applicationId: $applicationId
      commissionLevel: $commissionLevel
    ) {
      success
      errors {
        field
        message
      }
    }
  }
`

/** Envia el nivel ya guardado; por eso no recibe el nivel como argumento. */
export const SEND_AGENT_ONBOARDING_COMMISSION_PROPOSAL = gql`
  mutation sendAgentOnboardingCommissionProposal($applicationId: ID!) {
    sendAgentOnboardingCommissionProposal(applicationId: $applicationId) {
      success
      errors {
        field
        message
      }
      application {
        id
        commissionProposalSentAt
      }
    }
  }
`

export const UPLOAD_AGENT_ONBOARDING_DOCUMENT = gql`
  mutation uploadAgentOnboardingDocument(
    $applicationId: ID!
    $documentType: String!
    $file: Upload!
  ) {
    uploadAgentOnboardingDocument(
      applicationId: $applicationId
      documentType: $documentType
      file: $file
    ) {
      success
      errors {
        field
        message
      }
      document {
        documentType
        fileName
        fileUrl
        status
      }
    }
  }
`

export const DELETE_AGENT_ONBOARDING_DOCUMENT = gql`
  mutation deleteAgentOnboardingDocument($applicationId: ID!, $documentType: String!) {
    deleteAgentOnboardingDocument(applicationId: $applicationId, documentType: $documentType) {
      success
      errors {
        field
        message
      }
    }
  }
`

/**
 * Versión en texto plano para el envío multipart: `useUploadFile` arma el FormData del
 * spec de GraphQL multipart, donde `operations` lleva la query como string, no como AST.
 */
export const UPLOAD_AGENT_ONBOARDING_DOCUMENT_STR = `
  mutation uploadAgentOnboardingDocument($applicationId: ID!, $documentType: String!, $file: Upload!) {
    uploadAgentOnboardingDocument(applicationId: $applicationId, documentType: $documentType, file: $file) {
      success
      errors { field message }
      document { documentType fileName fileUrl status }
    }
  }
`

export const SET_AGENT_ONBOARDING_UPLINE = gql`
  mutation setAgentOnboardingUpline($applicationId: ID!, $uplineId: ID) {
    setAgentOnboardingUpline(applicationId: $applicationId, uplineId: $uplineId) {
      success
      errors {
        field
        message
      }
      application {
        id
        uplineName
      }
    }
  }
`

export const CREATE_AGENT_ONBOARDING_APPLICATION = gql`
  mutation createAgentOnboardingApplication(
    $fullName: String!
    $email: String!
    $phone: String
    $address: String
    $dateOfBirth: String
    $usState: String
    $uplineId: ID
    $reviewStatus: String
    $commissionLevel: Int
  ) {
    createAgentOnboardingApplication(
      fullName: $fullName
      email: $email
      phone: $phone
      address: $address
      dateOfBirth: $dateOfBirth
      usState: $usState
      uplineId: $uplineId
      reviewStatus: $reviewStatus
      commissionLevel: $commissionLevel
    ) {
      success
      errors {
        field
        message
      }
      application {
        id
      }
    }
  }
`

/** Edición de los datos de la solicitud desde el panel; sólo viaja lo que cambió. */
export const UPDATE_AGENT_ONBOARDING_APPLICATION = gql`
  mutation updateAgentOnboardingApplication(
    $applicationId: ID!
    $data: AdminApplicationInput!
  ) {
    updateAgentOnboardingApplication(applicationId: $applicationId, data: $data) {
      success
      errors {
        field
        message
      }
    }
  }
`

/** Da de alta la cuenta del CRM para un agente aprobado y la vincula a su solicitud. */
export const CREATE_USER_FROM_ONBOARDING_APPLICATION = gql`
  mutation createUserFromOnboardingApplication(
    $applicationId: ID!
    $npn: String!
    $email: String
    $password: String
  ) {
    createUserFromOnboardingApplication(
      applicationId: $applicationId
      npn: $npn
      email: $email
      password: $password
    ) {
      success
      invitationSent
      errors {
        field
        message
      }
      application {
        id
        createdUser {
          id
          email
          fullName
        }
      }
    }
  }
`
